import { createSlice } from '@reduxjs/toolkit';

const loadStateFromLocalStorage = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    return serializedState ? JSON.parse(serializedState) : null;
  } catch (error) {
    console.error('Could not load state from localStorage', error);
    return null;
  }
};

const initialState = {
  nearbyStores: loadStateFromLocalStorage('nearbyStores') || null,
  selectedStore:null,
};

const nearbyStoreSlice = createSlice({
  name: 'nearbyStore',
  initialState,
  reducers: {
    setNearbyStores: (state, action) => {
      state.nearbyStores = action.payload;
      localStorage.setItem('nearbyStores', JSON.stringify(action.payload));
    },
    setSelectedStore: (state, action) => {
      state.selectedStore = action.payload;
      //localStorage.setItem('selectedStore', JSON.stringify(action.payload));
    },
  },
});

export const { setNearbyStores, setSelectedStore } = nearbyStoreSlice.actions;
export default nearbyStoreSlice.reducer;
